import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import logo from "../../../images/Damas_univ.png";
import Search from "../../Search/Search";
import Title from "../../Title/Title";

interface Student {
  examNumber: string;
  studentName: string;
  fatherName: string;
  motherName: string;
  year: string;
  roomName: string;
  cheatingImage: string;
}

interface Course {
  name: string;
  code: string;
}

interface RiotControlProps {}

const RiotControl: React.FC<RiotControlProps> = () => {
  return (
    <>
      <Row>
        <Col>
          <Title title="ضبط الشغب" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم الطالب / اسم الطالب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className="  bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td>اسم المقرر</td>
                <td>رمز المقرر</td>
                <td>
                  <button className=" bg-[#F6F8F9] p-2 rounded-2xl">
                    تصدير كملف اكسل
                  </button>
                </td>
                <td className="px-10"></td>
                <td className="px-10"></td>
                <td className="px-10"></td>
                <td className="px-10"></td>
              </tr>
            </thead>

            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td>الرقم الامتحاني</td>
                <td>اسم الطالب ونسبته</td>
                <td>الاب</td>
                <td>الام</td>
                <td>السنة</td>
                <td>اسم القاعة</td>
                <td>تنزيل صورة وسيلة الغش</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>0000</td>
                <td>الاحمد أحمد</td>
                <td>احمد</td>
                <td>خلود</td>
                <td>2023</td>
                <td>اسم القاعة</td>
                <td className="flex justify-center items-center">
                  <img src={logo} className="w-16 h-16" />
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
};

export default RiotControl;
